import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_do_not_have_access_account_status_wage'

export const dataPointDefinition = {
  retracedId: 'workers_do_not_have_access_account_status_wage',
  name: 'Workers do not have access to the account status of all wage deductions (i.e. history of payments, current account balan',
  description:
    'The intent of this question is to understand if workers have access to the "account status" of all wage deductions that have occurred (i.e. history of payments, current account balances etc.)',
  meta: {
    slcpMeta: {
      key: 'wb-wage-103x',
      number: 'WB-WAGE-121-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-103x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35930,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
